import classNames from 'classnames';
import { Dropdown } from '@/shared/components/flip-ui-kit/Dropdown';

export const ApyPeriodSelect = <T extends { label: string }>({
  periods,
  selected,
  onChange,
  contentClassname,
}: {
  periods: readonly T[];
  selected: T;
  onChange: (period: T) => void;
  contentClassname?: string;
}) => (
  <Dropdown
    buttonContent={selected.label}
    showChevronIcon
    buttonContentClassname="w-fit gap-x-0 !border-none !bg-transparent !text-cf-light-2 !shadow-none hover:!text-cf-white data-[state=open]:!text-cf-white"
    chevronIconClassname="text-current"
    contentClassname={classNames('w-[88px] !text-14 [&_button]:h-[46px]', contentClassname)}
    scrollClassname="!max-h-none !overflow-y-visible"
    align="start"
    options={periods.map((period) => ({
      label: period.label,
      onClick: () => onChange(period),
    }))}
  />
);
